import { render, staticRenderFns } from "./Subscript.vue?vue&type=template&id=70a8b1ee&"
import script from "./Subscript.vue?vue&type=script&lang=js&"
export * from "./Subscript.vue?vue&type=script&lang=js&"
import style0 from "./Subscript.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports